import { useEffect, useState } from 'react'
import type { UserLink } from './types'

function isLinkActive(link: UserLink, useLocation = false) {
  if (typeof link === 'string') return false
  const linkActive = link.active === 'active'
  if (!useLocation) return linkActive
  if (!link.href) return linkActive
  let pathname = link.href
  try {
    pathname = new URL(link.href).pathname
  } catch {
    // probs a relative link, or with only a hash
  }
  return pathname === window.location.pathname || linkActive
}

function useLinkItemActive(link: UserLink) {
  const [active, setActive] = useState(isLinkActive(link, false))
  useEffect(() => {
    setActive(isLinkActive(link, true))
  }, [link])
  return active
}

export default useLinkItemActive
